import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../../_L1_components/Layout/Panel";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";

class ProbeSetupUsb extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
    };
    super(props, initState);
  }

  loadProbeSetup(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        if (this.props.onConfLoad) {
          this.props.onConfLoad();
        }
        this.apiStore.fire("get_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "usb",
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this._probe_setup_form.init({
                usb: data,
              });
              this.setState({
                data: data,
                loading: false,
              });
            }
          },
        });
      }
    );
  }

  saveProbeSetup(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("set_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "usb",
            value: data["usb"],
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loadProbeSetup();
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
        });
      }
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.loadProbeSetup();
  }

  onComponentWillUnmount() {
    this.mounted = false;
  }

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mb-4 rounded-bottom"
          //	header="WiFi"
          style={{
            minHeight: "100px",
          }}
        >
          <ReactOForm
            onSubmit={this.saveProbeSetup.bind(this)}
            unsavedWarning={true}
            onControllerReady={(form_controller) => {
              this._probe_setup_form = form_controller;
            }}
          >
            <Row>
              <Col xs={12}>
                <Row className="mb-3">
                  <Col xs={12} sm={6} lg={3}>
                    <ReactOFormInput
                      type="select"
                      data_key="usb"
                      label="Usb access protocol"
                      size="md"
                      default="rndis"
                      options={[
                        {
                          name: (
                            <span>
                              RNDIS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[-&gt; Microsoft]
                            </span>
                          ),
                          value: "rndis",
                        },
                        {
                          name: (
                            <span>NCM&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[-&gt; Apple]</span>
                          ),
                          value: "ncm",
                        },
                        //	{name: 'Disabled', value: 'disabled' }
                      ]}
                    />
                  </Col>
                </Row>

                {!this.state.loading && (
                  <div className="sub-title">
                    <p>
                      The WiFiProbe device has a micro-USB connector on one side, that can
                      be used to access the WiFiProbe stand-alone local web user
                      interface.
                    </p>
                    <p>
                      Once connected via a USB cable to a computer, the WiFiProbe device
                      presents itself as a USB ethernet network device, which allows you
                      to access the local user interface with your browser at the URL:{" "}
                      <a href="http://85.89.130.241" target="_blank" rel="noreferrer">
                        http://85.89.130.241
                      </a>{" "}
                    </p>
                    <p>
                      The only little annoyance is that Apple and Microsoft use two
                      different standards for this kind of USB ethernet network device, so
                      if you use:
                      <br />
                      <span style={{ paddingLeft: "1em" }}>
                        Microsoft Windows:&nbsp;&nbsp;configure as RNDIS
                      </span>
                      <br />
                      <span style={{ paddingLeft: "1em" }}>
                        Apple macOS:&nbsp;&nbsp;configure al NCM{" "}
                      </span>
                      <br />
                      <span style={{ paddingLeft: "1em" }}>
                        Linux:&nbsp;&nbsp;both RNDIS and NCM work fine
                      </span>
                    </p>
                  </div>
                )}
                <ReactOActionBar align="right" padding="0">
                  <ReactOFormInput type="submit" value="Save" color="primary" icon="save">
                    Save
                  </ReactOFormInput>
                </ReactOActionBar>
              </Col>
            </Row>
          </ReactOForm>
        </Panel>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(
  withRouter(ProbeSetupUsb),
  //	withDefinedContext(ProbeSetupUsb, 'ProbeSetupUsb', context_exposed_methods),
  {
    define: null,
  }
);
